import React from 'react';

const Table = (props) => {
    return (
        <table width="0%" border="0" cellSpacing="0" cellPadding="0" style={{
            width: "100%"
        }}>
            <tbody>
                <tr>
                    <td style={{
                        fontWeight: "bold",
                        fontSize: "20px",
                        textAlign: "left"
                    }}><span>{props.title}</span></td>
                </tr>
                {props.children}
            </tbody>
        </table>
    )
};

export default React.memo(Table);